import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import env from '@/env';

const Recaptcha = forwardRef<ReCAPTCHA>((_props, ref) => {
    return (
        <ReCAPTCHA
            sitekey={env.RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={ref}
        />
    );
});

export default Recaptcha;
